import { render, staticRenderFns } from "./futuresInfo.vue?vue&type=template&id=e67a0b9c&scoped=true"
import script from "./futuresInfo.vue?vue&type=script&lang=js"
export * from "./futuresInfo.vue?vue&type=script&lang=js"
import style0 from "./futuresInfo.vue?vue&type=style&index=0&id=e67a0b9c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e67a0b9c",
  null
  
)

export default component.exports